import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from 'src/app/shared/services/base-api.service';
import { GeneralResponse } from 'src/app/shared/shared-data-models';
import { environment } from 'src/environments/environment';
import { InvestorCompanyDetailsOutputDto } from '../../data-models/investor.data.models';

@Injectable({
  providedIn: 'root'
})
export class InvestorCompanyDataService {

  private controllerUrl: string = `${environment.appConfig.adminGatewayServiceBaseUrl}/api/1/InvestorCompany/`;

  constructor(
      private baseApi: BaseApiService<any>,
  ) { }

  InvestorCompanyDetails(investorId?:string,requestId?:string): Observable<GeneralResponse<InvestorCompanyDetailsOutputDto>> {
    const requestIdParam=requestId?`&requestId=${requestId}`:'';
    return this.baseApi.Get(`${this.controllerUrl}InvestorCompanyDetails?investorId=${investorId}${requestIdParam}`);
  }
}
